import React, { Component, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { login, logout } from "../../redux/logger/logActions";
import { Button, Typography, CircularProgress } from "@mui/material";
import {
  CancelOutlined,
  DeleteForeverOutlined,
  DeleteOutlineRounded,
  EditNote,
  ErrorOutline,
  HourglassEmpty,
} from "@mui/icons-material";
import axios from "axios";
import { basePath } from "../../utility";
const MyApplications = ({ currentTab, setCurrentTab }) => {
  const [origin, setOrigin] = useState("purchased");
  const [redirectUrl, setRedirectUrl] = useState("/user-profile");
  const [toggleAction, setToggleAction] = useState(false);
  const [actionLable, setActionLable] = useState("Read Book");
  const [selectedBook, setSelectedBook] = useState(null);

  const [deleteLoading, setDeleteLoading] = useState(false);
  const [deleteError, setDeleteError] = useState(null);

  const logger = useSelector((state) => {
    return state.logger;
  });

  const dispatch = useDispatch();

  // const loadApplications = async () => {
  //   try {
  //     let user = logger.user;

  //     let userApplications = [];
  //     let userId = logger.user.userId;

  //     const getUserApplications = await axios.get(
  //       `${basePath.url}application/my-applications/${userId}`
  //     );

  //     // console.log(getUserApplications);
  //     userApplications = [...getUserApplications.data.data];

  //     user.userApplications = userApplications;

  //     dispatch(login(user));
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  // useEffect(() => {
  //   loadApplications();
  // }, []);

  const handleDelete = async (id) => {
    try {
      setDeleteError(null);
      setDeleteLoading(true);

      if (logger.user.userApplications.length > 0) {
        let currentUser = { ...logger.user };
        let userApplications = logger.user.userApplications;
        userApplications = userApplications.filter((item, index) => {
          return item.id != id;
        });

        currentUser.userApplications = userApplications;
        dispatch(login(currentUser));
      }

      console.log(`${basePath.url}application/delete-application/${id}`);

      const deleteApplication = await axios.delete(
        `${basePath.url}application/delete-application/${id}`
      );

      setDeleteError(null);
      setDeleteLoading(false);
    } catch (error) {
      setDeleteError(error);
      setDeleteLoading(false);
    }
  };

  return (
    <>
      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center",
          flexWrap: "wrap",
          gap: 20,
          paddingTop: 30,
          paddingBottom: 30,
          boxSizing: "border-box",
        }}
      >
        {logger.user.userApplications.length > 0 &&
          logger.user.userApplications.map((application, index) => {
            return (
              <div key={index} className="clusterItemsContainer highlight-row">
                <div className="clusterItem">
                  <Typography variant="subtitle2" className="subHeader">
                    Application Number:
                  </Typography>
                  <Typography variant="subtitle2" className="subItem">
                    {application.application_number}
                  </Typography>
                </div>
                <div className="clusterItem">
                  <Typography variant="subtitle2" className="subHeader">
                    Program Name:
                  </Typography>
                  <Typography variant="subtitle2" className="subItem">
                    {application.programName}
                  </Typography>
                </div>
                <div className="clusterItem">
                  <Typography variant="subtitle2" className="subHeader">
                    Intake Period:
                  </Typography>
                  <Typography variant="subtitle2" className="subItem">
                    {application.intakePeriodName}
                  </Typography>
                </div>
                <div className="clusterItem">
                  <Typography variant="subtitle2" className="subHeader">
                    Status:
                  </Typography>
                  <Typography
                    variant="subtitle2"
                    className="subItem"
                    color={
                      application.status == "PENDING SUBMISSION"
                        ? "red"
                        : "green"
                    }
                    style={{ fontWeight: 500, fontSize: 16 }}
                  >
                    {application.status}
                  </Typography>
                </div>
                {application.status == "PENDING SUBMISSION" ? (
                  <>
                    <div
                      className="clusterItem"
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "flex-start",
                        alignItems: "flex-end",
                      }}
                    >
                      <Button
                        variant="outlined"
                        size="medium"
                        style={{ border: "none", marginTop: 10 }}
                        startIcon={<EditNote style={{ color: "green" }} />}
                      >
                        Edit
                      </Button>
                    </div>
                    <div
                      className="clusterItem"
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "flex-start",
                        alignItems: "flex-end",
                      }}
                    >
                      <Button
                        variant="outlined"
                        size="medium"
                        style={{ border: "none", marginTop: 10 }}
                        startIcon={<CancelOutlined style={{ color: "grey" }} />}
                        onClick={() => {
                          handleDelete(application.id);
                        }}
                      >
                        {deleteLoading ? <CircularProgress /> : "Delete"}
                      </Button>
                    </div>
                  </>
                ) : null}
              </div>
            );
          })}

        {logger.user.userApplications.length < 1 && (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
            }}
          >
            <ErrorOutline style={{ fontSize: 50, color: "orange" }} />
            <Typography variant="subtitle2">
              No Application Made! Please Click on the "Add New Application"
              Button to add your application
            </Typography>
            <Button
              variant="outlined"
              style={{ borderColor: "green", color: "#07330b", marginTop: 10 }}
              onClick={() => {
                setCurrentTab("Add New");
              }}
            >
              Add New Application
            </Button>
          </div>
        )}
      </div>
    </>
  );
};

export default MyApplications;
